import React from 'react';
import { Icon } from 'ui';
import LinkButton from 'components/shared/LinkButton';
import { useSelectedFilters } from 'components/shared/FilterContext';
import SelectedFilterBadge from './SelectedFilterBadge';

const SelectedFilters = () => {
  const { selectedFilters, removeAll, removeOne, hasSelected, renderSelected } =
    useSelectedFilters();

  if (!hasSelected) return null;

  return (
    <div className="ff-ss">
      <Icon name="filter" className="mr-8 mt-1" />
      {selectedFilters.map((selected, i) => (
        <SelectedFilterBadge
          // eslint-disable-next-line react/no-array-index-key
          key={`${selected.type}.${renderSelected(selected)}.${i}`}
          onRemove={() => removeOne(selected)}
        >
          {renderSelected(selected)}
        </SelectedFilterBadge>
      ))}
      <LinkButton type="primary" className="ml-8 fz-bigger" onClick={removeAll}>
        {t('insights.filters.clear_all')}
      </LinkButton>
    </div>
  );
};

export default SelectedFilters;
